// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require("dotenv").config();
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import VueAnalytics from "vue-analytics";
import store from '@/store/index'

Vue.use(require("vue-moment"));

Vue.use(VueAxios, axios);

Vue.use(VueAnalytics, {
  id: "UA-91308668-3",
  router
});

Vue.config.productionTip = false;

// var coinsRef = Firebase.database.ref('coinStorage');

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js